import { category } from '@/__generated__/requests'

export const isBudgetCategory = (value: any): value is category =>
  Object.values(category).includes(value)
